'use client'

import React from "react"
import PropTypes from "prop-types";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const ConfirmDialog = ({
  openDialog,        // Controla si el diálogo está abierto o cerrado
  onClose,           // Función para cerrar el diálogo
  title,             // Título del diálogo
  description,       // Descripción que se muestra en el diálogo
  onAccept,           // Función que se ejecuta cuando se hace click en "Agree"
  onCancel         // Función que se ejecuta cuando se hace click en "Disagree"
}) => {

  return (
    <React.Fragment>
      <Dialog
        open={openDialog}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" display={'flex'} justifyContent={'space-around'} alignItems={'center'}>
          {title} <WarningIcon sx={{ color: 'orange', fontSize: '40px'}} />
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {description}
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button color="error" variant="outlined" onClick={onCancel}>Cancelar</Button>
          <Button sx={{
            backgroundColor: '#148f9f',
            '&:hover': {
              backgroundColor: '#148f9f', // color al hacer hover
            }
            }} variant="contained" onClick={onAccept} autoFocus>
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

ConfirmDialog.propTypes = {
  openDialog: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmDialog;
